import $ from 'jquery';
import 'slick-carousel';

export function initGallery() {
    if (window.acf) {
        window.acf.addAction(
            'render_block_preview/type=services-carousel',
            gallery
        );
    }
}

export function gallery() {
    if (!document.querySelector('.gallery__slider')) return false;

    $('.gallery__slider').slick({
        slidesToShow: 5,
        slidesToScroll: 5,
        arrows: false,
        responsive: [
            {
                breakpoint: 840,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                },
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
        ],
    });

    // Previous | Next Buttons
    Array.from(document.querySelectorAll('.gallery__arrow')).forEach(function (
        button
    ) {
        button.addEventListener('click', function () {
            $('.gallery__slider').slick(
                `slick${button.getAttribute('data-direction')}`
            );
        });
    });

    let main = document.querySelector('.gallery .gallery-main');
    let tumbs = document.querySelectorAll('.gallery .gallery-thumb');

    [...tumbs].forEach((v, i, a) => {
        v.addEventListener('click', (e) => {
            let img = v.querySelector('img');
            let new_main_src = img.dataset.main;
            let img_main = main.querySelector('img');
            img_main.setAttribute('src', new_main_src);
        });
    });
}
